import * as toastr from "toastr";
import { Utilservice } from '@core/services/util.service';

class CanSaveVisitsService {
  public execute(
    lsVisitsChecked: any[],
    nextWeekOfDulorenTimestamp: number[]
  ){
    if(lsVisitsChecked.length === 0){
      toastr.error("Preencha todos os campos.");

      return false;
    }

    const canSave = !lsVisitsChecked.some(e => {
      if (
        e.inOrder == 0 ||
        e.inOrder == "" ||
        (!e.day && Utilservice.dateIsInDulorenNextWeek(nextWeekOfDulorenTimestamp, e.dataPrev, 'DD/MM/YYYY')) ||
        e.inOrder == null 
        // ||
        // !e.idFormaVisita
      ) {
        return true;
      }

      return false
    })

    if(!canSave){
      toastr.error("Preencha todos os campos.");
    }

    return canSave;
  }
}


export {CanSaveVisitsService};
